import { Location } from './Location';

export function imgPath(img: string) {
  return StaticAssetsUrlPrefix + `img/${img}?${BuildId}`;
}

export function imgUrl(img: string) {
  const path = imgPath(img);
  return `url(${path})`;
}

export function backgroundImageUrl(img: string) {
  const path = imgPath(img);
  return `url("${path}")`;
}

export function initializeUrlPrefix(prefix: string) {
  StaticAssetsUrlPrefix = prefix ? (prefix + '/') : '';
  if (Location.instance.hostname().toLowerCase() === 'localhost' && Location.instance.search().toLowerCase().indexOf('usecdn') === -1) {
    StaticAssetsUrlPrefix = '';
  }

  if (StaticAssetsUrlPrefix) {
    // Currently there are many CSS styles are defined in Stylus files (.styl).
    // All the Stylus scripts are exected during build time.
    // We don't have any control of the code in those files during run time.
    // In order to let the image URLs to consume the CDN prefix,
    // We have to manipulate the actual stylesheets dynamically during the run time.
    const stylesheets = document.styleSheets;
    for (let i = 0; i < stylesheets.length; i++) {
      const stylesheet = stylesheets[i];
      for (let j = 0; j < stylesheet.cssRules.length; j++) {
        const cssStyleRule = stylesheet.cssRules[j] as CSSStyleRule;
        try {
          if (cssStyleRule.style && cssStyleRule.style.backgroundImage && cssStyleRule.style.backgroundImage.indexOf('url("img/') !== -1) {
            cssStyleRule.style.backgroundImage = cssStyleRule.style.backgroundImage.replace(/url\("img\//g, 'url("' + StaticAssetsUrlPrefix + 'img/');
          }

          const cssFontFaceRule = stylesheet.cssRules[j] as CSSFontFaceRule;
          if (cssFontFaceRule.style && cssFontFaceRule.style.getPropertyValue('src').indexOf('url("img/') !== -1) {
            cssFontFaceRule.style.setProperty('src', cssFontFaceRule.style.getPropertyValue('src').replace(/url\("img\//g, 'url("' + StaticAssetsUrlPrefix + 'img/'));
          }
        } catch (e) {
          // for any case if the CSS manipulation fails, igonre the failure to avoid breaking the whole page.
        }
      }
    }
  }
}